var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appmain",style:(`height: calc(100vh - ${_vm.headerH}px);`)},[_c('div',{staticStyle:{"height":"100%","padding-top":"10px"}},[_c('transition',{attrs:{"name":" fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }